import { Injectable } from '@angular/core';
import { BaseApiService, Result } from '@shared/data-access';
import { TableDataResponse } from '@shared/ui/tables';
import { Observable } from 'rxjs';
import { OfficerResponse } from '../models/list-officer.models';

@Injectable({
  providedIn: 'root',
})
export abstract class BaseListOfficerService {
  constructor(public api: BaseApiService) {}

  abstract list(query: string): Observable<Result<TableDataResponse<OfficerResponse>>>;

  abstract deleteOfficer(uid: string): Observable<string>;

  abstract inviteUser(uid: string): Observable<string>;
}
